import { isBrowser } from "../../common/helpers/env";
/* eslint-disable */
export const getItem = (sKey: string) => {
    if (!sKey || !isBrowser) {
        return null;
    }
    return (
        decodeURIComponent(
            document.cookie.replace(
                new RegExp(
                    "(?:(?:^|.*;)\\s*" +
                        encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") +
                        "\\s*\\=\\s*([^;]*).*$)|^.*$"
                ),
                "$1"
            )
        ) || null
    );
};
export const setItem = (sKey: string, sValue: string | boolean, vEnd: number | string | Date, sPath = "/", sDomain?: string, bSecure?: boolean) => {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey) || !isBrowser) {
        return false;
    }
    var sExpires = "";
    if (vEnd) {
        switch (vEnd.constructor) {
            case Number:
                sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                break;
            case String:
                sExpires = "; expires=" + vEnd;
                break;
            case Date:
                sExpires = "; expires=" + (vEnd as Date).toUTCString();
                break;
        }
    }
    document.cookie =
        encodeURIComponent(sKey) +
        "=" +
        encodeURIComponent(sValue) +
        sExpires +
        (sDomain ? "; domain=" + sDomain : "") +
        (sPath ? "; path=" + sPath : "") +
        (bSecure ? "; secure" : "");
    return true;
};
export const removeItem = (sKey: string, sPath?: string, sDomain?: string) => {
    if (!hasItem(sKey) || !isBrowser) {
        return false;
    }
    document.cookie =
        encodeURIComponent(sKey) +
        "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" +
        (sDomain ? "; domain=" + sDomain : "") +
        (sPath ? "; path=" + sPath : "");
    return true;
};
export const hasItem = (sKey: string) => {
    if (!sKey || !isBrowser) {
        return false;
    }
    return new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(
        document.cookie
    );
};
export const keys = () => {
    if (!isBrowser) return null;
    var aKeys = document.cookie
        .replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "")
        .split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
        aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }
    return aKeys;
};
